import Login from './pages/login';
import Logout from './pages/logout';

export const AuthRoutes = [
  {
    path: '/login',
    exact: true,
    component: () => <Login />,
  },
  {
    path: '/logout',
    exact: true,
    component: () => <Logout />,
  },
];
